import { useState } from "react";
import { toast } from "@/lib/toast";
import api from "@/lib/api";

const fmtM2 = (v) => `${Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²`;
const inp = { width: "100%", background: "#101013", border: "0.5px solid #2a2a30", borderRadius: 5, padding: "6px 8px", fontSize: 10.5, color: "#e8e8ec" };
const lbl = { fontSize: 9.5, color: "#6e6e78", letterSpacing: ".05em", display: "block", marginBottom: 3, textTransform: "uppercase" };

/** Affichage d'une surface : uniquement la valeur finale courante (la traçabilité vit dans l'onglet Historique). */
export function SurfaceValue({ plan, rect, size = 11.5, color = "#c9c9d1", testId }) {
  return <span className="tabular-nums" style={{ fontSize: size, color }} data-testid={testId} data-rectified={rect ? "true" : undefined}>{fmtM2(rect ? rect.value : plan)}</span>;
}

/** Panneau « Rectifier une surface » (Admin / Premier Admin) — portée : ce lot uniquement. */
export default function SurfaceRectifyPanel({ lotId, options, rectifications = {}, onSaved, onClose }) {
  const [target, setTarget] = useState(options[0]?.key || "");
  const [value, setValue] = useState("");
  const [motif, setMotif] = useState("");
  const [busy, setBusy] = useState(false);
  const cur = options.find((o) => o.key === target);
  const plan = cur ? Number((rectifications[target]?.plan) ?? cur.plan ?? 0) : 0;
  const real = value === "" ? null : Number(value);
  const diff = real != null && !Number.isNaN(real) ? real - plan : null;
  const pct = diff != null && plan > 0 ? Math.round((diff / plan) * 100) : null;
  const save = async () => {
    if (!target) return toast.error("Choisissez une surface à rectifier");
    if (!(real > 0)) return toast.error("Surface réelle obligatoire");
    if (!motif.trim()) return toast.error("Motif obligatoire");
    setBusy(true);
    try { await api.post(`/crm/lots/${lotId}/rectify`, { target, value: real, motif: motif.trim() }); toast.success("Rectification enregistrée"); onSaved?.(); onClose?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  return (
    <div style={{ background: "#18181c", border: "0.5px solid #2f2650", borderRadius: 9, padding: 12, marginTop: 10 }} data-testid="lot-rectify-panel">
      <span style={lbl}>Surface à rectifier</span>
      <div className="flex flex-wrap" style={{ gap: 6, marginBottom: 10 }}>
        {options.map((o) => { const on = o.key === target; return (
          <button key={o.key} type="button" onClick={() => setTarget(o.key)} style={{ padding: "4px 10px", borderRadius: 12, fontSize: 10.5, background: on ? "#1c1730" : "#101013", border: `0.5px solid ${on ? "#7c5cd0" : "#2a2a30"}`, color: on ? "#c4b3ea" : "#8b8b93" }} data-testid={`lot-rectify-target-${o.key.replace(":", "-")}`}>{o.label}</button>
        ); })}
      </div>
      <div style={{ fontSize: 10.5, color: "#8b8b93", marginBottom: 8 }} data-testid="lot-rectify-plan">Au plan : {fmtM2(plan)}</div>
      <div className="grid" style={{ gridTemplateColumns: "160px 1fr", gap: 10 }}>
        <label><span style={lbl}>Surface réelle m² <span style={{ color: "#d97a7a" }}>*</span></span><input type="number" min="0" step="0.01" value={value} onChange={(e) => setValue(e.target.value)} style={inp} data-testid="lot-rectify-value" /></label>
        <label><span style={lbl}>Motif de la rectification <span style={{ color: "#d97a7a" }}>*</span></span><textarea value={motif} onChange={(e) => setMotif(e.target.value)} style={{ ...inp, minHeight: 60, resize: "vertical" }} data-testid="lot-rectify-motif" /></label>
      </div>
      {diff != null && (
        <div style={{ fontSize: 10.5, marginTop: 8, color: diff < 0 ? "#e79a9a" : "#7fd6ab" }} data-testid="lot-rectify-diff">
          Écart : {diff > 0 ? "+" : "−"}{fmtM2(Math.abs(diff))}{pct != null ? ` (${diff > 0 ? "+" : "−"}${Math.abs(pct)} %)` : ""}
        </div>
      )}
      <div className="flex justify-end" style={{ gap: 8, marginTop: 12 }}>
        <button type="button" onClick={onClose} style={{ background: "#18181c", border: "0.5px solid #2e2e34", borderRadius: 7, padding: "7px 14px", fontSize: 11.5, color: "#c9c9d1" }} data-testid="lot-rectify-cancel">Annuler</button>
        <button type="button" onClick={save} disabled={busy} style={{ background: "#6d3fbf", borderRadius: 7, padding: "7px 14px", fontSize: 11.5, color: "#fff", opacity: busy ? .6 : 1 }} data-testid="lot-rectify-save">Enregistrer la rectification</button>
      </div>
    </div>
  );
}
